import { MimeType } from 'vet-bones/constants';
import { QueryBuilderModel } from 'vet-bones/utils/queryBuilder';

import { RulesInfo } from 'src/containers/PublishProjectDrawer/types';
import { newline } from 'src/templates/copy';
import { ExportToFileOptions } from 'src/utils/exportToFile';
import { stringifyRules } from 'src/utils/stringify/rules/rules';
import { stringToFilename } from 'src/utils/stringToFilename';

export const exportRules = (
  name: string,
  model: QueryBuilderModel,
  ruleInfo: RulesInfo,
  fileNamePrefix = ''
): ExportToFileOptions | null => {
  const rules = stringifyRules(model, ruleInfo);
  if (!rules) {
    return null;
  }

  const filename = `${fileNamePrefix}${stringToFilename(name)}.srs`;
  const contents = rules + newline;

  return { contents, filename, mimeType: MimeType.TURTLE };
};
